<template>
  <div class="investment-card-info-numbers">
    <div class="investment-card-info-numbers__container">
      <exc-labeled-value
        v-for="(item, indx) in info"
        :key="indx"
        class="investment-card-info-numbers__info mb-24 mb-0--ml"
        :class="{
          'bor--left bor--transp-02': indx % 2 !== 0
        }"
        align="center"
        direction="column"
      >
        <template #label>
          <span class="txt--14px txt--height-18px txt--color-03">
            {{ item.title }}
          </span>
        </template>
        <template #default>
          <span
            class="txt--bold txt--16px txt--height--20px txt--color-04"
          >
            {{ item.value }}
          </span>
        </template>
      </exc-labeled-value>
    </div>
  </div>
</template>

<script>
import InvestmentPlanModel from '@/lib/data-models/investment/InvestmentPlanModel'
import { ExcLabeledValue } from '@/components/common'
import { formatNumber } from '@/lib/utils'

export default {
  name: 'InvestmentCardInfoNumbers',
  components: {
    ExcLabeledValue,
  },
  props: {
    investment: {
      // TODO: fix to type
      type: InvestmentPlanModel,
      // type: Object,
      required: true,
    },
  },
  computed: {
    maxDeposit () {
      const maxDeposit = this.investment.maxDeposit
      return maxDeposit === 'staking.noLimit'
        ? this.$t(maxDeposit)
        : +maxDeposit
    },
    info () {
      const profitCondition = this.investment.minPercent && this.investment.minPercent.equals(this.investment.maxPercent)
      let profitValue = ''

      if (profitCondition) {
        profitValue = formatNumber(this.investment.minPercent)
      } else {
        profitValue = `${formatNumber(this.investment.minPercent)}% - ${formatNumber(this.investment.maxPercent)}`
      }

      const items = [
        {
          title: this.$t('staking.investmentCard.profit'),
          value: profitValue,
        },
        {
          title: this.$t('staking.investmentCard.planAmount'),
          value: formatNumber(this.investment.planCount),
        },
        {
          title: this.$t('staking.investmentCard.min'),
          value: formatNumber(this.investment.minDeposit),
        },
        {
          title: this.$t('staking.investmentCard.max'),
          value: formatNumber(this.maxDeposit),
        },
      ]

      return items
    },
  },
}
</script>

<style lang="scss" scoped>
.investment-card-info-numbers {
  &__container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    @include bp(ml) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &__info {
    @include bp(ml) {
      border-left: 1px solid color('transp-02');

      &:first-child {
        border-left: none;
      }
    }
  }
}
</style>
